// Hero Section
export function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden">
      {/* Background com gradiente */}
      <div className="absolute inset-0 bg-gradient-to-br from-green-50 to-white dark:from-gray-900 dark:to-gray-950" />

      {/* Decorative shapes */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-green-100 rounded-full opacity-20 blur-3xl" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-green-100 rounded-full opacity-20 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 dark:text-gray-100 mb-6 leading-tight">
            Sistema de gestão financeira{' '}
            <span className="text-green-600">inteligente e prático</span>
            <br />
            para o seu negócio
          </h1>

          <p className="text-xl md:text-2xl text-green-600 font-semibold mb-4">
            Simples, prático e rápido.
          </p>

          <p className="text-lg md:text-xl text-gray-600 dark:text-gray-300 mb-6 max-w-3xl mx-auto">
            Emissão de <strong>qualquer tipo de nota fiscal</strong> (produto e serviço).
            Funciona com notas fiscais de <strong>qualquer lugar do Brasil</strong>.
          </p>

          <p className="text-lg text-gray-500 dark:text-gray-400 mb-10">
            Comece grátis e sem inserir dados de pagamento.
          </p>

          <button
            onClick={() => scrollToSection('pricing')}
            className="px-8 py-4 bg-green-600 hover:bg-green-700 text-white text-lg font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
          >
            Comece agora
          </button>
        </div>
      </div>
    </section>
  );
}
